import React from 'react';

function Header({ isStartingPage = false, onProfileClick }) {
  return (
    <div className={`main-header ${isStartingPage ? 'not-sticky' : ''}`}>
      <div className="container-fluid px-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className="logo-container me-2">
              <img src="/logos/logo.png" alt="logo" className="main-logo" />
            </div>
          </div>
          <div className="profile-icon" onClick={onProfileClick}>
            <i className="bi bi-person-circle fs-1 text-purple"></i>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;

